import changeAssigneeByRegionReducer from "./changeAssigneeByRegionReducer";
import changeAssigneeByHeadquartersReducer from "./changeAssigneeByHeadquartersReducer";

const changeAssigneeReducers = {
    changeAssigneeByRegion: changeAssigneeByRegionReducer,
    changeAssigneeByHeadquarters: changeAssigneeByHeadquartersReducer,
}

export default changeAssigneeReducers;